import React, { createContext, useContext, useMemo } from 'react';
import { useFxRates } from '../hooks/useFxRates';

type FxCtx = {
  displayCode: string;
  displaySymbol: string;
  rates: Record<string, number> | null;
  toDisplay: (amount: number, fromCurrency?: string | null) => number;
};

const FxContext = createContext<FxCtx | null>(null);

export function FxRatesProvider({
  currency,
  children,
}: {
  currency: string;
  children: React.ReactNode;
}) {
  const fx = useFxRates(currency);
  const value = useMemo(
    () => ({
      displayCode: fx.displayCode,
      displaySymbol: fx.displaySymbol,
      rates: fx.rates,
      toDisplay: fx.toDisplay,
    }),
    [fx.displayCode, fx.displaySymbol, fx.rates, fx.toDisplay],
  );
  return <FxContext.Provider value={value}>{children}</FxContext.Provider>;
}

export function useFx(): FxCtx {
  const ctx = useContext(FxContext);
  if (!ctx) {
    return {
      displayCode: 'RUB',
      displaySymbol: '₽',
      rates: null,
      toDisplay: (amount: number) => amount,
    };
  }
  return ctx;
}
